import "../styles.css";
import "./about.scss";
import clinicImage from "../assets/clinic.jpg";
import Separator from "./Separator/separator";

export default function About() {
  return (
    <section className="about" id="about">
      <div className="about-content">


      </div>
      <div className='leftImgMobile'></div>
            <div className="txtAbout">
                
                <div className='leftImg'></div>

                <div className="rightBoard">
                    <div className='logoText'>
                        <p className='dizeres'>"Com uma abordagem integral e múltiplas especialidades, garantimos um cuidado completo para sua saúde bucal. Agende sua avaliação clínica e veja como podemos ajudar."</p>
                        <h1 className='titulo'>CUIDE DO SEU SORRISO</h1>                    
                    </div>
                    
                    <input 
                        type="button"                        
                        className="btnAgendarInst"
                        value="Agende uma avaliação"
                        onClick={(e) => {
                            e.preventDefault();
                            window.open("https://wa.me/5511930693338?text=Oi!%20Gostaria%20de%20receber%20atendimento.", "_blank");
                            // Rastreamento de conversão do Google Ads
                            if (window.gtag) {
                                window.gtag('event', 'conversion', {
                                    'send_to': 'AW-16944490858/aL4_CM-jl7MaEOrS4Y8_',
                                    'value': 1
                                });
                            }
                        }}
                    />
                </div> 
            </div>     
    </section>
  );
}